import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getAllContent,
  getContentById,
  updateContent,
} from "./content.service";

const key = "jeep-rally-content";

export const useGetAllContent = (options = {}) => {
  return useQuery({
    queryKey: [key, "all"],
    queryFn: getAllContent,
    ...options,
  });
};

export const useGetContentById = (id, options = {}) => {
  return useQuery({
    queryKey: [key, id],
    queryFn: () => getContentById(id),
    enabled: Boolean(id) && options.enabled !== false,
    ...options,
  });
};

export const useUpdateContentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ contentId, payload }) =>
      updateContent(contentId, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [key] });
      if (variables?.contentId) {
        queryClient.invalidateQueries({
          queryKey: [key, variables.contentId],
        });
      }
    },
  });
};
